<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/ImpactActivities/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>